var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('iframe',{attrs:{"src":`https://scoolhelp.com/?bearer=${_vm.token}&application=${_vm.application}&language=${_vm.language}`,"frameborder":"0","height":"100%","width":"100%"}})
}
var staticRenderFns = []

export { render, staticRenderFns }